/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  setTimeout(() => {
    const inventory_content = document.querySelector('#inventory-info-app');
    const productForm = document.querySelector('.product__submit__buttons');

    if (productForm && inventory_content) {
      // const inventory_span = inventory_content.querySelector('#location-inventory-teaser');

      // if (inventory_span) {
      //   inventory_span.innerHTML = `
      //     <a href="#" id="model_btn">In Stock at <u>Pink Chicken Bethesda</u> and 3 more locations</a>
      //   `
      // }
      inventory_content.style.display = 'block';
      productForm.append(inventory_content)
    }
  }, 5000);


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
  const wrapper = document.querySelector('[data-products-grid]');
  const productItems = document.querySelectorAll('.product-item .product-item__swatch');
  const siblingItems = document.querySelectorAll('.product-item product-siblings [data-scrollbar]');

  bindLoadMore();
  onFiltersOrSortUpdated();
  optionsEvent();
  enableMoreBtns();
  
  window.addEventListener('resize', function () {
    enableMoreBtns();
  });

  function enableMoreBtns () {
    if (window.innerWidth < 749) {
      productItems.forEach(pItem => {
        const items = pItem.querySelectorAll('a');
        const moreSpan = pItem.querySelector('#more-btn');
  
        if (items.length > 3 && !moreSpan) {
          pItem.innerHTML += `<span class="product-item__swatch-more">+More</span>`;
        }
      });

      siblingItems.forEach(pItem => {
        const items = pItem.querySelectorAll('tooltip-component');
        const moreSpan = pItem.querySelector('#more-btn');

        if (items.length > 3 && !moreSpan) {
          pItem.innerHTML += `<span class="product-item__swatch-more">+More</span>`;
        }
      });
    } else {
      productItems.forEach(pItem => {
        const moreSpan = pItem.querySelector('.product-item__swatch-more');
        if (moreSpan) {
          moreSpan.remove();
        }
      });

      siblingItems.forEach(pItem => {
        const moreSpan = pItem.querySelector('.product-item__swatch-more');
        if (moreSpan) {
          moreSpan.remove();
        }
      });
    }
  }

  function bindLoadMore () {
    const button = document.getElementById('load-more');
    if (!button || button.dataset.bound === 'true') return;
    button.dataset.bound = 'true';
    if (button) {
      button.addEventListener('click', function handleClick() {
        const nextUrl = this.dataset.nextUrl;
        this.disabled = true;
        this.textContent = 'Loading...';
  
        fetch(nextUrl)
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newProducts = doc.querySelectorAll('#CollectionLoop > *');
            const newButton = doc.querySelector('#load-more');
            
            newProducts.forEach(product => {
              wrapper.querySelector('.grid').appendChild(product);
            });
  
            if (newButton) {
              this.replaceWith(newButton);
              bindLoadMore();
            } else {
              this.remove(); // No more pages
            }

            optionsEvent();
          })
          .catch(() => {
            this.textContent = 'Failed to load';
          });
      });
    }
  }

  function debounce(fn, delay = 150) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  const debouncedUpdate = debounce(() => {
    // Wait until is-loading is removed
    const checkInterval = setInterval(() => {
      if (!wrapper.classList.contains('is-loading')) {
        clearInterval(checkInterval);
        //onFiltersOrSortUpdated();
      }
    }, 100);
  }, 150);

  function onFiltersOrSortUpdated() {
    if (getCookie('filters') && JSON.parse(getCookie('filters'))) {
      const activeFilters = JSON.parse(getCookie('filters'));
      const filterAccordions = document.querySelectorAll('#Filter-accordion .filter-group details');
      activeFilters.forEach(filterValue => {
        filterAccordions.forEach(filter => {
          const label = filter.getAttribute('data-label');
          if (filterValue.label === label ) {
            if (filterValue.isOpen) {
              filter.setAttribute('open', true);
              filter.querySelector('.filter-group__body').style.height = 'auto';
            }
          }
        }); 
      });
    }
  }

  function getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (let c of cookies) {
      const [key, val] = c.split('=');
      if (decodeURIComponent(key) === name) {
        return decodeURIComponent(val);
      }
    }
    return null;
  }

  function setCookie(name, value, days) {
    const expires = days
      ? `; expires=${new Date(Date.now() + days * 864e5).toUTCString()}`
      : '';
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value || '')}${expires}; path=/`;
  }

  if (wrapper) {
    const observer = new MutationObserver((mutations) => {
      const collectionLoopReplaced = mutations.some(m =>
        [...m.addedNodes].some(node =>
          node.nodeType === 1 && node.id === 'CollectionLoop'
        )
      );
      if (collectionLoopReplaced) {
        debouncedUpdate();
        bindLoadMore();
        optionsEvent();
      }
    });

    observer.observe(wrapper, {
      childList: true,
      subtree: true // watch for replacements inside
    });
  }

  function optionsEvent() {
    const optionBtns = document.querySelectorAll('[js-option-btn]');
    optionBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();

        btn.classList.add('is-loading');
        const variantId = Number(btn.getAttribute('data-variant-id'));

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                quantity: 1,
                id: variantId,
              }
            ]
          })
        }).then(res => res.json()).then(response => {
          document.dispatchEvent(
            new CustomEvent('theme:cart:refresh')
          );
          btn.classList.remove('is-loading');
        }).catch(e => {
          btn.classList.remove('is-loading');
        })
      });
    });
  }
})();